import { useEffect, useState } from "react";
import io from "socket.io-client";
import apiService from "./common_api";
import { SyncOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import common_mapping from "./common_mapping";

// const BASE_URL="https://sap-integration-app-dot-nimble-equator-282207.nw.r.appspot.com"

const SyncStatus = ({ globalList, setGlobalList }) => {
  const [loadings, setLoadings] = useState(false);
  const [statuses, setStatuses] = useState("Complete Sync");
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    const socket = io();

    // Listen for connection events
    socket.on('connect', () => {
      socket.emit("getsyncStatus");
    });

    socket.on('disconnect', (reason) => {
      setLoadings(false);
      setDisabled(false);
      setStatuses("Complete Sync");
    });

    socket.on('reconnect', (attempt) => {
    });

    socket.on('syncStatusUpdate', async ({ store, status, error, data }) => {

      if (status === "COMPLETED") {
        if (data) {
          let vari_mapped_data = [], sap_mapped_data = [], simple_mapped_data = [], bundle_mapped_data = [], kit_mapped_data = [];

          if (data.variant_data) {
            vari_mapped_data = await common_mapping.map_variant(data.variant_data)
          }
          if (data.sap_data) {
            sap_mapped_data = await common_mapping.map_saplist(data.sap_data)
          }
          if (data.simple_data) {
            simple_mapped_data = await common_mapping.map_simplelist(data.simple_data)
          }
          if (data.bundle_data) {
            bundle_mapped_data = await common_mapping.map_bundleList(data.bundle_data)
          }
          if (data.kit_data) {
            kit_mapped_data = await common_mapping.map_kitList(data.kit_data)
          }
          const updatedData = {
            ...(bundle_mapped_data?.length > 0 && { bundle_datalist: bundle_mapped_data }),
            ...(kit_mapped_data?.length > 0 && { kit_datalist: kit_mapped_data }),
            ...(sap_mapped_data?.length > 0 && { sap_datalist: sap_mapped_data }),
            ...(simple_mapped_data?.length > 0 && { simple_datalist: simple_mapped_data }),
            ...(vari_mapped_data?.length > 0 && { variant_datalist: vari_mapped_data }),
          };
          await setGlobalList(prev => ({
            ...prev,
            ...updatedData
          }));
        }

        setLoadings(false);
        setDisabled(false);
        setStatuses("Complete Sync");
      }
      if (status === "IN_PROGRESS") {
        setLoadings(true);
        setDisabled(true);
        setStatuses("Sync in Progress");
      }
    });

    return () => {
      socket.off('syncStatusUpdate');
      socket.off('connect');
      socket.off('disconnect');
      socket.off('reconnect');
    };
  }, []);

  const handleSync = async () => {
    setLoadings(true);
    setDisabled(true);
    await apiService.syncAll();
  };

  return (
    <div>
      <div>
        <Button
          type="primary"
          disabled={disabled}
          onClick={handleSync}
          loading={loadings ? <SyncOutlined spin /> : ""}>
          {statuses}
        </Button>
      </div>
    </div>
  );
};

export default SyncStatus;
